@if (materialType && materialTypeNameToIconConfig[materialType.name]) {
  <mat-icon class="material-type-icon" [svgIcon]="materialTypeNameToIconConfig[materialType.name].iconString"/>
} @else {
  <mat-icon class="material-type-icon" svgIcon="help-circle-outline"/>
}
